export default __webpack_public_path__ + "static/media/132-singapore.a9cd3372.svg";